/* global gtag */
import { useContext, useEffect, useState, useRef } from 'react';
// import ArticleContext from './contexts/ArticleContext';

// export function useArticleLoadEvent(articleId) {
//   const firstArticleId = useContext(ArticleContext);

//   useEffect(() => {
//     console.log(`loaded ${articleId} on page ${firstArticleId}`);
//     gtag('event', 'article_load', {
//       article: articleId,
//       page: firstArticleId,
//       'non-interaction': true,
//     });
//   }, [articleId, firstArticleId]);
// }

export function useYouTube() {
  const [init, setInit] = useState(true);
  const promiseRef = useRef(null);

  if (init) {
    setInit(false);

    promiseRef.current = new Promise((resolve) => {
      window.onYouTubeIframeAPIReady = () => {
        resolve(window.YT);
      };
    });

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  return promiseRef.current;
}
